export default function HeroSection() {
  return (
    <section className="relative h-[620px] md:h-[720px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20lifestyle%20product%20flatlay%20photography%20with%20soft%20natural%20daylight%20on%20light%20marble%20surface%2C%20scattered%20fashion%20accessories%20sneakers%20and%20fabric%20textiles%20arranged%20artistically%2C%20warm%20neutral%20cream%20and%20beige%20tones%2C%20soft%20gentle%20shadows%2C%20editorial%20catalog%20aesthetic%2C%20airy%20bright%20peaceful%20atmosphere%2C%20minimal%20clean%20composition%2C%20high%20end%20product%20photography%20style%20with%20subtle%20texture&width=1920&height=960&seq=gtbuy-hero-bg&orientation=landscape"
        alt="GTBuy Spreadsheet lifestyle product photography"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/35"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center w-full max-w-3xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-white leading-tight mb-4">
            Find the Best Deals Using
            <br />
            <span className="text-white/90">GTBuy Spreadsheet</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
            Compare prices across Kakobuy Spreadsheet &amp; Superbuy Spreadsheet. A data-driven product comparison system that helps you make smarter shopping decisions.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-3.5 rounded-full text-base font-semibold bg-white text-foreground-900 hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              GTBuy Sheet
              <i className="ri-arrow-right-up-line ml-2 text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line ml-2 text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}